import { Link, useLocation } from 'react-router-dom';

interface Props {
    title: string;
    id: number;
    tab: string;
}

export const RegisterItemLinkCell = ({ title, id, tab }: Props) => {
    const { pathname } = useLocation();

    return <Link to={`${pathname}/update-${id}#${tab}`}>{title}</Link>;
};
